import React, { Component } from 'react'; // eslint-disable-line no-unused-vars
import { Transition, TransitionGroup } from 'react-transition-group';
import IconX from '../Icons/svg/IconX.js';

const Alert = (props) => {
    const { className, category, onClose, children } = props;
    const componentClass = 'alert';
    let classList = componentClass;

    classList = category ? `${classList} ${componentClass}--${category}` : classList;
    classList = className ? `${classList} ${className}` : classList;

    return (
        <div className={classList}>
            <div className="alert__body">{children}</div>
            {onClose && (
                <span className="alert__close" onClick={onClose}>
                    <IconX className="alert__close-svg" />
                </span>
            )}
        </div>
    );
};
Alert.defaultProps = {
    onClose: null,
};

const AlertList = (props) => {
    const { className, right, bottom, children } = props;
    const componentClass = 'alert-list';
    let classList = componentClass;

    classList = right ? `${classList} ${componentClass}--right` : classList;
    classList = bottom ? `${classList} ${componentClass}--bottom` : classList;
    classList = className ? `${classList} ${className}` : classList;

    return (
        <div className={classList}>
            {bottom ? React.Children.toArray(children).reverse() : children}
        </div>
    );
};

class Notifier extends Component {
    constructor (props) {
        super(props);

        this.state = {
            alerts: {},
            counter: 0,
        };

        this.create = this.create.bind(this);
        this.remove = this.remove.bind(this);
    }

    create (text, category = 'default') {
        const key = this.state.counter + 1;
        this.setState((prevState) => {
            return {
                ...prevState,
                counter: key,
                alerts: {
                    ...prevState.alerts,
                    [key]: {
                        text,
                        category,
                    },
                },
            };
        });

        if (this.props.timeout) {
            setTimeout(() => {
                this.remove(key);
            }, this.props.timeout);
        }
        return key;
    }

    remove (key) {
        const alerts = { ...this.state.alerts };
        delete alerts[key];
        this.setState({ alerts });
    }

    render () {
        const { right, bottom } = this.props;
        const { alerts } = this.state;

        return (
            <AlertList right={right} bottom={bottom}>
                <TransitionGroup component={null}>
                    {
                        Object.keys(alerts).map(key => {
                            const alert = alerts[key] || null;
                            return alert && (
                                <Transition timeout={200} key={key} appear={true}>
                                    {(state) => {
                                        return (
                                            <Alert
                                                className={`alert--${state}`}
                                                category={alert.category}
                                                onClose={() => {
                                                    this.remove(key);
                                                }}
                                            >
                                                {alert.text}
                                            </Alert>
                                        );
                                    }}
                                </Transition>
                            );
                        })
                    }
                </TransitionGroup>
            </AlertList>
        );
    }
}
Notifier.defaultProps = {
    timeout: 4000,
    right: false,
    bottom: false,
};

export { Alert, AlertList, Notifier };
